import includes from 'lodash/includes';
import find from 'lodash/find';
import union from 'lodash/union';
import head from 'lodash/head';
import filter from 'lodash/filter';
import { initStore } from '../useStore';
import usePrice from "../usePrice";
import Ticket from "../../utils/tickets";
import DialogBox from '../../UIComponents/DialogBox';

const configStore = () => {
  const actions = {};
  
  initStore(actions, {
    appData: null,
    nextSectionName: null,
    nextSection: null,
    checkoutStep: 1,
    checkoutStepped: 1,
    lastStep: 3,
    deluxeTickets: [],
    parking: null,
    // deluxeTickets: [[
    //   { time: "2020-05-05T10:00:00Z", free: 100, eventID: "90-1063901" },
    //   { time: "2020-05-05T12:00:00Z", free: 100, eventID: "90-1063901" },
    //   { time: "2020-05-05T15:00:00Z", free: 100, eventID: "90-1063901" }
    // ], [
    //   { time: "2020-05-06T10:00:00Z", free: 100, eventID: "90-1063901" },
    //   { time: "2020-05-06T12:00:00Z", free: 100, eventID: "90-1063901" },
    //   { time: "2020-05-06T15:00:00Z", free: 100, eventID: "90-1063901" }
    // ], [
    //   { time: "2020-05-07T10:00:00Z", free: 100, eventID: "90-1063901" },
    //   { time: "2020-05-07T12:00:00Z", free: 100, eventID: "90-1063901" },
    //   { time: "2020-05-07T15:00:00Z", free: 100, eventID: "90-1063901" }
    // ], [
    //   { time: "2020-05-08T10:00:00Z", free: 100, eventID: "90-1063901" },
    //   { time: "2020-05-08T12:00:00Z", free: 100, eventID: "90-1063901" },
    //   { time: "2020-05-08T15:00:00Z", free: 100, eventID: "90-1063901" }
    // ], [
    //   { time: "2020-05-09T10:00:00Z", free: 100, eventID: "90-1063901" },
    //   { time: "2020-05-09T12:00:00Z", free: 100, eventID: "90-1063901" }
    // ]],
    btsTickets: [],
    // btsTickets: [[
    //   { time: "2020-06-04T09:30:00Z", free: 100, eventID: "101-1063901" },
    //   { time: "2020-06-04T11:00:00Z", free: 100, eventID: "101-1063901" }
    // ], [
    //   { time: "2020-06-05T09:30:00Z", free: 100, eventID: "101-1063901" },
    //   { time: "2020-06-05T11:00:00Z", free: 100, eventID: "101-1063901" }
    // ], [
    //   { time: "2020-06-11T09:30:00Z", free: 100, eventID: "101-1063901" },
    //   { time: "2020-06-11T11:00:00Z", free: 100, eventID: "101-1063901" }
    // ], [
    //   { time: "2020-06-12T09:30:00Z", free: 100, eventID: "101-1063901" },
    //   { time: "2020-06-12T11:00:00Z", free: 100, eventID: "101-1063901" }
    // ], [
    //   { time: "2020-06-18T09:30:00Z", free: 100, eventID: "101-1063901" },
    //   { time: "2020-06-18T11:00:00Z", free: 100, eventID: "101-1063901" }
    // ], [
    //   { time: "2020-06-19T09:30:00Z", free: 100, eventID: "101-1063901" },
    //   { time: "2020-06-19T11:00:00Z", free: 100, eventID: "101-1063901" }
    // ], [
    //   { time: "2020-06-22T09:30:00Z", free: 100, eventID: "101-1063901" },
    //   { time: "2020-06-22T11:00:00Z", free: 100, eventID: "101-1063901" }
    // ], [
    //   { time: "2020-06-23T09:30:00Z", free: 100, eventID: "101-1063901" },
    //   { time: "2020-06-23T11:00:00Z", free: 100, eventID: "101-1063901" }
    // ], [
    //   { time: "2020-06-24T09:30:00Z", free: 100, eventID: "101-1063901" },
    //   { time: "2020-06-24T11:00:00Z", free: 100, eventID: "101-1063901" }
    // ]],
    tickets: [],
    fares: [],
    cartState: [],
    selectedEvent: null,
    hasParking: false,
    parkingEventID: null,
    giftAddon: null,
    giftAddonName: null,
    giftWinter: false,
    hasAddons: true,
    isGroup: false,
    totals: {
      people: 1,
      tickets: 1,
      availablePackages: 1,
      adults: 1
    },
    firstName: '',
    lastName: '',
    email: '',
    address1: '',
    address2: '',
    city: '',
    geostate: '',
    postal: '',
    country: '',
    phone: '',
    affiliate: null,
    deliveryMethod: 'eTicket',
    deliveryPrice: 0,
    deliveryAddress1: '',
    deliveryAddress2: '',
    deliveryCity: '',
    deliveryState: '',
    deliveryPostal: '',
    deliveryCountry: '',
    quantityLimit: 23,
    dayLimit: null,
    clientState: { "cat": "WBSTD", "lang": "en", "tq": [], "iq": [], "sessionRemaining": 0, "reset": false, "services": [], "servtext": "", "servcontact": "", "discount": "", "status": "", "type": "", "amount": "", "discountID": "", "discountData": { "amount": "", "discountCode": "", "discountID": "", "status": "", "type": "" }, "delivery": { "firstName": "", "lastName": "", "email": "", "address1": "", "address2": "", "city": "", "state": "", "postal": "", "affiliate": "" }, "billing": { "firstName": "", "lastName": "", "email": "", "address1": "", "address2": "", "city": "", "state": "", "postal": "" },"evdate": null, "evid": null, "deliveryMethod": "eTicket" }
  });
};

export default configStore;
